export interface NavItem {
  label: string;
  href: string;
}

export const navItems: NavItem[] = [
  { label: 'Capabilities', href: '#services' },
  { label: 'About', href: '#about' },
  { label: 'Portal', href: '#portal' },
  { label: 'Contact', href: '#contact' },
];

/** Stable module-level list of the section ids the nav points at. */
export const sectionIds: string[] = navItems.map((item) => item.href.slice(1));
